package com.ives.utils.math;

import haxe.ds.Vector;

class LineSegment {
	public var first:Vector2D;
	public var second:Vector2D;

	public function new(?a:Vector2D, ?b:Vector2D) {
		if(a == null)
			a = new Vector2D();

		if(b == null)
			b = new Vector2D();

		this.first = a;
		this.second = b;
	}

	public function getBoundingBox():Vector<Vector2D>{
		var result = new Vector<Vector2D>(2);

		result[0] = new Vector2D(Math.min(first.x, second.x), Math.min(first.y, second.y));
		result[1] = new Vector2D(Math.max(first.x, second.x), Math.max(first.y, second.y));

		return result;
	}
}
